import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-147" data-mp="uh7a9gd2bhjy">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="fjevwrj94z7c">
          <header className="text-center" data-id="element-149" data-mp="fkg6yw09plp2">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-150" data-mp="ki8akna9yw93">
              KIT CUIDADOS EN CAMA
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-[17px] font-medium" data-id="element-151" data-mp="3le06prry6gqm">
              Guías y recursos prácticos para organizar el cuidado diario de tu familiar en cama con mayor claridad y confianza.
            </p>
          </header>
          <div className="mx-auto mt-10 max-w-3xl rounded-2xl border border-primary/30 bg-canvas px-5 py-7 text-center sm:px-8" data-id="element-152" data-mp="3udn8ieol9ok7">
            <p className="text-foreground-muted" data-id="element-153" data-mp="32obql4sr94vb">
              Con nuestro <b className="text-foreground" data-id="element-154" data-mp="32otjbrg7l0yh">sistema de uso sencillo</b>, seguís cuatro pasos:
            </p>
            <p className="mt-4 font-display text-lg font-bold text-primary-soft sm:text-3xl" data-id="element-155" data-mp="2xne0m61i76j9">
              ABRIR <span className="text-highlight" aria-hidden="true" data-id="element-156" data-mp="3bizryjv7m2eu">→</span> LEER <span className="text-highlight" aria-hidden="true" data-id="element-157" data-mp="36pdh8x8lw8lo">→</span> SEGUIR <span className="text-highlight" aria-hidden="true" data-id="element-158" data-mp="2j02mbwdxt8fg">→</span> APLICAR
            </p>
            
            
          </div>
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-159" data-mp="2eyheipg9fkc4">
            📚 4 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-160" data-mp="hwil1z5r82s7">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-161" data-mp="rp7jntg7hm64" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-162" data-mp="8wn3ncllvbjq" />
                  <div className="flex-1" data-id="element-163" data-mp="dxt27r1y5t16">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-164" data-mp="duexic5t97qk">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-165" data-mp="1pavgugkhk8ip">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm font-semibold tracking-label text-foreground-subtle" data-id="element-166" data-mp="39w1zi1xh8vay">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-167" data-mp="302utceuwxb9t">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-168" data-mp="2v5um40mbu2h4">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-169" data-mp="2q6rkyr9gwgef" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-170" data-mp="2h5tm0ndvyz2p">
                      <span className="font-semibold text-foreground-subtle" data-id="element-171" data-mp="2c7rsf8iu3hcz">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-172" data-mp="fclv0gowut0z">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-173" data-mp="344pkhat9628a" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-174" data-mp="3885ahoath4c0">
        <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="387m3v3qma2da">
          <header className="text-center" data-id="element-176" data-mp="2u95nel2ycxhy">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-177" data-mp="2u84aeb2dm0xl" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-178" data-mp="2z6fjukore9fa">
              5 BONOS DE REGALO
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-179" data-mp="2p9aygn2qmhzj">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-180" data-mp="2bg1u50tncmnv">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-181" data-mp="21l0504zdfkla">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-182" data-mp="1mwqcihygdwj5">
                  <h3 className="font-bold" data-id="element-183" data-mp="1mxjkfm95es2v">{title}</h3>
                  {detail && <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-184" data-mp="1iwg12prw6dww">
                      {detail}
                    </p>}
                  <ul className="mt-3 space-y-1.5" data-id="element-185" data-mp="1wtcsotfu3zeu">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-186" data-mp="1rvl3w8ahktev">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-187" data-mp="25ukpt86m6u7c" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-188" data-mp="2fl5pkyy0y4ru">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-189" data-mp="2anvpmpd0eapr">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-190" data-mp="2pl69alzt2mwk">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-191" data-mp="2kmuxw6tv44c8">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-192" data-mp="2wkyok0ah8pwf">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-193" data-mp="31kl4willqm9g">
              VALOR TOTAL DE LOS BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-194" data-mp="3bcz5v94uvouk">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-195" data-mp="3fchtwdrz4g1m">
              GRATIS con tu KIT CUIDADOS EN CAMA
            </p>
          </div>
        </div>
      </section>
    </>;
}